// Module
var code = "<div data-bind=\"visible: enable, click: action, css: { 'active' : isActive() }\">\r\n  <bp-img class=\"icon\" params=\"iconName: icon\"></bp-img>\r\n  <div class=\"text\">\r\n    <span class=\"label\" data-bind=\"text: label\"></span>\r\n    <span class=\"description\" data-bind=\"text: description\"></span>\r\n  </div>\r\n</div>\r\n";
// Exports
module.exports = code;